import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import '.././styles/Popup.css';

function ControlledPopup ({ open, onClose, title, description, linkName, link }) {
  return (
    <Popup open={open} closeOnDocumentClick onClose={onClose} modal>
      <div className="modal">
        <button type="button" className="close" onClick={onClose} aria-label="Close popup">
          &times;
        </button>
        <div id="popup-layout">
          <h3>{title}</h3>
          <p>{description}</p>
          {link &&
            <div id="popup-button">
              <a href={link} target="_blank" rel="noopener noreferrer" className="button-2">
                {linkName}
              </a>
            </div>
          }
        </div>
      </div>
    </Popup>
  );
};

export default ControlledPopup;
